module.exports = __webpack_public_path__ + "img/female.4729d06b.svg";